import { ReactNode } from 'react';
import { NavDropdown, Dropdown } from 'react-bootstrap';
import { useLogout } from '../../Logout';

interface UserSettingsProps {
    login: string;
    isAdmin: boolean;
    missionPlannerUrl: string;
}

function UserSettings({ login, isAdmin, missionPlannerUrl }: UserSettingsProps): ReactNode {
    const isAstra = process.env.REACT_APP_SERVICE === 'astra';

    const logout = useLogout();

    return (
        <NavDropdown
            align="end"
            title={
                <img className='menu-box-icon' src="/image/modem/user.svg" alt="" />
            }
            id='collapsible-nav-dropdown' menuVariant="dark">
            <Dropdown.ItemText>{login}</Dropdown.ItemText>
            <Dropdown.Divider />
            {isAdmin &&
                <>
                    <NavDropdown.Item as="button" onClick={() => window.location.href = "/settings"}>Settings</NavDropdown.Item>
                    <NavDropdown.Item as="button" onClick={() => window.location.href = "/statistics"}>Statistics</NavDropdown.Item>
                    <NavDropdown.Item as="button" onClick={() => window.location.href = "/onlineDrones"} href='onlineDrones'>OnlineDrones</NavDropdown.Item>
                    <NavDropdown.Item as="button" onClick={() => window.location.href = "/users"} href='users'>Users</NavDropdown.Item>
                    <NavDropdown.Item as="button" onClick={() => window.location.href = "/firmware"} href='firmware'>Firmware</NavDropdown.Item>
                    <NavDropdown.Item as="button" onClick={() => window.location.href = "/adminSubscriptions"} href='firmware'>Subscriptions</NavDropdown.Item>
                    <Dropdown.Divider />
                </>
            }
            {isAstra &&
                <>
                    <NavDropdown.Item as="button" onClick={() => window.location.href = "/subscriptions"} href='firmware'>Управление подписками</NavDropdown.Item>
                    <Dropdown.Divider />
                </>
            }
            <NavDropdown.Item as="button" onClick={() => { window.open(missionPlannerUrl, "_blank") }}>Скачать Mission Planner</NavDropdown.Item>
            <Dropdown.Divider />
            <NavDropdown.Item as="button" onClick={logout}>Выход</NavDropdown.Item>
        </NavDropdown>
    );
}

export default UserSettings;